export default __webpack_public_path__ + "5b0a58268c264da0cece7304c8fdd1dd.svg";